import React, { useState } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Avatar,
  Box,
  Typography,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import CustomPagination from "../../../../../components/CustomPagination";
import profile from "../../../../../assets/ViewLeave-images/Payroll.svg";
import { ReactComponent as Edit } from "../../../../../assets/images/edit.svg";
import styles from "./style";
import { formatDate } from "../../../../../utils/DateFormat";

const SalaryManagementList = ({
  data,
  count,
  page,
  setPage,
  handleUpdate,
  handleShowPdf,
  isProcessed,
  isPayslipAccessDisabled,
  // getPayslipsPdf
}) => {
  const navigate = useNavigate();
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [processedIds, setProcessedIds] = useState([]);

  const handleNavigateView = (id) => {
    if (isPayslipAccessDisabled) return;
    handleShowPdf(id)
    navigate("/dashboard/viewInvoice", { state: { item: { flag: "paylist", id: id } } });
  }

  const role = localStorage.getItem("role");
  const isEmployee =
    role === "Employee" || role === "employee";

  const handleProcess = (id) => {
    handleUpdate(true, id);
  };

  return (
    <TableContainer
      sx={{
        maxWidth: "100%", // Ensures container adjusts to the viewport
        overflowX: "auto", // Enables horizontal scrolling for small screens
      }}
    >
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow>
            <TableCell sx={styles.TableHead}>Name</TableCell>
            <TableCell sx={styles.TableHead}>Gross Income</TableCell>
            <TableCell sx={styles.TableHead}>Net Pay</TableCell>
            <TableCell sx={styles.TableHead}>Salary</TableCell>
            <TableCell sx={styles.TableHead}>From</TableCell>
            <TableCell sx={styles.TableHead}>To</TableCell>
            <TableCell sx={styles.TableHead}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.length === 0 ? (
            <TableRow>
              <TableCell colSpan={7} align="center">
                <Typography variant="h6">No data</Typography>
              </TableCell>
            </TableRow>
          ) : (
            data.map((item, index) => {
              const isItemProcessed = item?.isPaid === true;
              return (
                <TableRow key={index}>
                  <TableCell sx={styles.tableAvtardata}>
                    <Avatar src={profile} sx={styles.profileAvtar} />
                    <Box>
                      <Typography sx={styles.name}>
                        {item?.employeeDetails[0]?.personalInfo?.firstName}{" "}
                        {item?.employeeDetails[0]?.personalInfo?.surName}
                      </Typography>
                      <Typography sx={styles.mail}>
                        Employee Id: {item?.employeeDetails[0]?.stafId}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell sx={styles.tabledata}>{item?.grossInc}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.netPay}</TableCell>
                  <TableCell sx={styles.tabledata}>
                    {item?.employeeDetails[0]?.salaryInfo?.salary}{" "}
                  </TableCell>
                  <TableCell sx={styles.tabledata}>
                    {formatDate(item?.from)}
                  </TableCell>
                  <TableCell sx={styles.tabledata}>
                    {formatDate(item?.to)}
                  </TableCell>
                  <TableCell sx={styles.tabledata}>
                    <Box sx={styles.tableActiondata}>
                      {!isEmployee && (
                        <Button
                          variant="contained"
                          sx={{
                            ...styles.exportbtn,
                            backgroundColor: isItemProcessed
                              ? "secondary"
                              : "SkyBlue",
                            color: "white",
                            "&:hover": {
                              backgroundColor: isItemProcessed
                                ? "secondary"
                                : "SkyBlue",
                            },
                            cursor: isItemProcessed ? "default" : "pointer",
                          }}
                          onClick={
                            isItemProcessed ? null : () => handleProcess(item._id)
                          }
                        >
                          {isItemProcessed ? "Processed" : "Process"}
                        </Button>
                      )}
                      <RemoveRedEyeOutlinedIcon
                        sx={{
                          ...styles.viewIcon,
                          cursor: isPayslipAccessDisabled ? "not-allowed" : "pointer",
                          opacity: isPayslipAccessDisabled ? 0.4 : 1,
                        }}
                        onClick={() => handleNavigateView(item._id)}
                      />
                    </Box>
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
      <CustomPagination
        pageCount={count}
        totalItems={count}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      />
      {/* {PDF && (
        <Grid
          container
          sx={{
            mx: "16px",
            mb: "28px",
            p: "10px !important",
            px: "20px",
            pb: "30px",
            borderRadius: "20px",
            display: "flex",
            justifyContent: "space-between",
            mt: 0,
          }}
        >
          <PdfViewer pdf={PDF} />
        </Grid>
      )} */}
    </TableContainer>
  );
};

export default SalaryManagementList;
